<template>
    <div class="tw-text-center tw-flex tw-flex-col tw-items-center tw-justify-center">
        <h3>Call <strong>(877)-360-3843</strong> now<br class="lg:tw-hidden"> to <strong>get a free quote</strong></h3>
        <div class="form-success tw-text-center tw-py-4 tw-px-3 lg:tw-pt-8 lg:tw-px-12 lg:tw-pb-8">
            <h4>Thank you for your interest!</h4>
            <p>Our recommended home security provider is Vivint. They will call you shortly to provide a <strong>FREE</strong> quote. Want to chat now? You can call <strong>877-360-3843</strong> to get started.</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormSuccess',
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';

h3 {
    width: 100%;
    background-color: $main_color;
    color: #fff;
    font-size: 18px;
    line-height: 22px;
    @screen lg {
        padding: 0 32px;
        width: fit-content;
        border-radius: 5px;
        font-size: 26px;
        line-height: 62px;
    }
}

.form-success {
    background-color: #fff;
    box-shadow: 0 4px 4px -2px #707070;
    @screen lg {
        margin: 0 auto;
        border-radius: 5px;
        max-width: 680px;
        transform: translateY(-10px);
    }

    h4 {
        color: $second_color;
        font-weight: 700;
        font-size: 24px;
        line-height: 28px;
        @screen lg {
            font-size: 30px;
            line-height: 50px;
        }
    }

    p {
        color: $second_color;
        font-size: 15px;
        line-height: 20px;
        @screen lg {
            font-size: 20px;
            line-height: 24px;
        }
    }
}

</style>
